import { PersonSearchAction, PersonSearchActionTypes, PersonSearchAppState, PersonSearchKeys, PersonSearchState, SearchPerson } from './person-search-model';

const InitialState: PersonSearchState = {
    searchResults: [],
    hideToast: false,
};

const InitialAppState: PersonSearchAppState = {
    [PersonSearchKeys.MaritalStatus]: InitialState,
    [PersonSearchKeys.Dependents]: InitialState,
    [PersonSearchKeys.GroupAdminAdd]: InitialState,
    [PersonSearchKeys.OfficerAdd]: InitialState,
    [PersonSearchKeys.NewHire]: InitialState,
    [PersonSearchKeys.DomesticPartner]: InitialState,

};

export const personSearchReducer = (state = InitialAppState, action: PersonSearchAction): PersonSearchAppState => {
    const { key } = action;

    switch (action.type) {
        case PersonSearchActionTypes.SET_RESULTS:
            return {
                ...state,
                [key]: {
                    ...state[key],
                    searchResults: action.payload,
                },
            };
        case PersonSearchActionTypes.SET_TOAST:
            return {
                ...state,
                [key]: {
                    ...state[key],
                    hideToast: action.payload,
                },
            };
        
        default: return state;
    }
};

export const setSearchResults = (results: SearchPerson[], key: PersonSearchKeys): PersonSearchAction => {
    return {
        type: PersonSearchActionTypes.SET_RESULTS,
        payload: results,
        key,
    };
};

export const setHideToast = (hideToast: boolean, key: PersonSearchKeys): PersonSearchAction => {
    return {
        type: PersonSearchActionTypes.SET_TOAST,
        payload: hideToast,
        key,
    };
};